// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.droplets-modal {
    min-width: 67rem;
}

.droplets-modal .calculation-container {
    width: 15rem;
}

.droplets-modal .modal-radio-buttons {
    width: 50%;
    min-width: -moz-fit-content;
    min-width: fit-content;
}

.negotiated-price-input-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.negotiated-dollar-sign {
  left: 16px;
  position: absolute; 
  font-size: .8rem;
}

.negotiated-price-input {
  flex: 1 1;
  padding: 0 16px 0 32px;
}

.class-search-container {
    position: relative;
}

.class-search-inner {
  position: relative;
}

.class-search-container > .class-search-inner > .input {
  min-width: 21rem;
}

#network-checkbox-container > div {
  flex: 1 1;
  justify-content: center;
}

.header-row-no-margin .header-no-margin {
  margin: 0; 
}

.filters-container {
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: max-height 0.4s ease-in-out, opacity 0.4s ease-in-out;
}

.filters-container.filters-visible {
  max-height: 500px;
  opacity: 1;
  overflow: visible;
}

.refresh-icon-link {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/modals/DropletsModal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,2BAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,sBAAsB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,iEAAiE;AACnE;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".droplets-modal {\n    min-width: 67rem;\n}\n\n.droplets-modal .calculation-container {\n    width: 15rem;\n}\n\n.droplets-modal .modal-radio-buttons {\n    width: 50%;\n    min-width: fit-content;\n}\n\n.negotiated-price-input-wrapper {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.negotiated-dollar-sign {\n  left: 16px;\n  position: absolute; \n  font-size: .8rem;\n}\n\n.negotiated-price-input {\n  flex: 1;\n  padding: 0 16px 0 32px;\n}\n\n.class-search-container {\n    position: relative;\n}\n\n.class-search-inner {\n  position: relative;\n}\n\n.class-search-container > .class-search-inner > .input {\n  min-width: 21rem;\n}\n\n#network-checkbox-container > div {\n  flex: 1;\n  justify-content: center;\n}\n\n.header-row-no-margin .header-no-margin {\n  margin: 0; \n}\n\n.filters-container {\n  overflow: hidden;\n  max-height: 0;\n  opacity: 0;\n  transition: max-height 0.4s ease-in-out, opacity 0.4s ease-in-out;\n}\n\n.filters-container.filters-visible {\n  max-height: 500px;\n  opacity: 1;\n  overflow: visible;\n}\n\n.refresh-icon-link {\n  display: flex;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
